import React, { useState } from 'react';
import { useProjectModel } from '../../../model.js';
import { generateDashboardPage } from './generate.js';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import { RouteStep, TitleStep } from './steps.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';

export const useGenerateDashboardPage = () => {
  const { model } = useProjectModel();

  const [pageTitle, setPageTitle] = useState<string>();
  const [pageRoute, setPageRoute] = useState<string>();

  const pageQuestionsAnswered = pageRoute && pageTitle;

  const generationTask = useGenerationTask(async () => {
    if (!pageQuestionsAnswered) {
      return;
    }

    return generateDashboardPage(model.projectFolder, pageRoute, pageTitle);
  }, [pageQuestionsAnswered]);

  return [
    <TitleStep pageTitle={pageTitle} onSubmit={setPageTitle} />,
    <RouteStep
      pageTitle={pageTitle}
      pageRoute={pageRoute}
      onSubmit={setPageRoute}
    />,
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={'dashboard page'}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        // https://dev.wix.com/docs/wix-cli/guides/extensions/dashboard-extensions/dashboard-pages/add-dashboard-page-extensions
        learnMoreUrl: 'https://wix.to/ARrI1ZX',
      })}
      route={pageRoute}
    />,
  ];
};
